import { useEffect } from 'react';
import { useQuery } from 'react-query';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Col } from '@guestyci/foundation/Layout';
import createStyles from '@guestyci/foundation/createStyles';
import { getActiveListings } from 'API/handlers/getCompanyInfo';
import track from 'utils/dio/trial-locked-flow';
import TrialDialogContent from '../module/TrialPeriod/TrialDialogContent';
import { selectTrialPeriod } from '../store/selector';

const useStyles = createStyles({
  root: {
    height: '100%',
  },
});
const TrialWebView = () => {
  const classes = useStyles();
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);
  const daysLeft = searchParams.get('daysLeft')
    ? Number(searchParams.get('daysLeft'))
    : 0;
  const defaultTrialDuration = 14;
  const { isSuspended, dayOfTrial, subscriptionCancelled } =
    useSelector(selectTrialPeriod);
  const trialDuration = searchParams.get('trialDuration')
    ? Number(searchParams.get('trialDuration'))
    : defaultTrialDuration;

  const { isFetched, data: activeListingsCount } = useQuery({
    queryKey: 'getActiveListings',
    queryFn: getActiveListings,
  });

  useEffect(() => {
    if (isFetched) {
      track.endOfTrialPopUpView(
        {
          isSuspended,
          dayOfTrial,
          activeListingsCount: activeListingsCount.data,
        },
        !subscriptionCancelled
      );
    }
  }, [
    dayOfTrial,
    isFetched,
    isSuspended,
    activeListingsCount,
    subscriptionCancelled,
  ]);

  return (
    <Col className={classes.root} fullWidth align="center">
      <TrialDialogContent trialDuration={trialDuration} daysLeft={daysLeft} />
    </Col>
  );
};

export default TrialWebView;
